import { UI } from '@gik/ui';
import { userStoreApi } from '../store/UserStore';
import { isBrowser } from '@/utils/environment';
import { auth } from '@gik/auth';

let displayedError = false;

const kyUnauthorizedHook = (_request, _options, response: Response) => {
  if (response.status === 420 && isBrowser()) {
    // unauthorized - custom HTTP code
    if (!displayedError) {
      displayedError = true;
      // TODO: replace with auth.logout()
      userStoreApi.getState().logout();
      (async () => {
        // TODO: use translation
        await UI.error('Your session has expired. Please log in');
        // TODO: replace with auth.login()
        auth.login();
      })();
    }
  }
};

export default kyUnauthorizedHook;
